import { render, staticRenderFns } from "./InitData.vue?vue&type=template&id=bc42da5a&scoped=true&"
import script from "./InitData.vue?vue&type=script&lang=js&"
export * from "./InitData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc42da5a",
  null
  
)

export default component.exports